export default __webpack_public_path__ + "static/media/kraft_paper.1bcb7e2d.png";